import type { AudioAnnotationField } from '@/features/nectar/api/models'
import type { ComponentType } from 'react'
import { MultiSelectField } from './MultiSelectField'
import { RatingField } from './RatingField'
import { SingleSelectField } from './SingleSelectField'
import { ToggleField } from './ToggleField'

export type FieldComponentProps = {
  field: AudioAnnotationField
  value: unknown
  onChange: (value: unknown) => void
  fieldsClassName?: string
}

export const FIELD_COMPONENTS = new Map<AudioAnnotationField['type'], ComponentType<FieldComponentProps>>([
  ['single-select', SingleSelectField as ComponentType<FieldComponentProps>],
  ['multi-select', MultiSelectField as ComponentType<FieldComponentProps>],
  ['toggle', ToggleField as ComponentType<FieldComponentProps>],
  ['rating', RatingField as ComponentType<FieldComponentProps>]
])
